
import { mapActions, mapGetters } from 'vuex';
import { isMobileResponsive } from '@/utils/mixins';

export default {
  name: 'CreatePortfolioOperationModalFooter',
  mixins: [isMobileResponsive],
  props: {
    buttonState: {
      type: String,
      default: 'disabled',
    },
    buttonTooltip: {
      type: String,
      default: '',
    },
    totalAmount: {
      type: Number,
      default: 0,
    },
    chosenCurrency: {
      type: String,
      default: '',
    },
    /*
     * Validation message to display for order validity
     * null if validity not instanciated
     * empty string if validity is true
     * error message if validity is false
     */
    orderValidityMessage: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('modals', [
      'createPortfolioOperationModal',
      'showPortfolioAssetOperationModalFooter',
    ]),
    isOrderInvalid() {
      return Boolean(this.orderValidityMessage);
    },
  },
  methods: {
    ...mapActions('modals', ['submitPortfolioOperationForm']),
    handleOperationSubmit(multipleTransactions) {
      this.submitPortfolioOperationForm(multipleTransactions);
      this.$emit('setMultipleTransactions', multipleTransactions);
    },
  },
};
